module.exports = __webpack_public_path__ + "static/media/AfricanAnimals.355487ae.png";